module.exports = __webpack_public_path__ + "img/breakfast_title--success.51cc6ba2.png";